import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

/**
 * Floating "back to top" pill that pins to the bottom-right of the viewport.
 * Only appears after the user has scrolled ~300px down the main window and
 * smooth-scrolls back to the top on click.
 *
 * Mounts to the document scroll — no `targetRef` needed. Safe to render
 * anywhere; only one instance should be on a page at a time.
 */
export default function BackToTop({ threshold = 300, testId = "back-to-top" }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  if (!visible) return null;

  return (
    <button
      type="button"
      data-testid={testId}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      title="Back to top"
      aria-label="Back to top"
      className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 px-3 py-2 border border-[#27272A] bg-[#0A0A0A]/95 backdrop-blur-sm text-zinc-300 hover:text-white hover:border-[#FF3B30] hover:bg-[#FF3B30]/10 text-[10px] uppercase tracking-widest font-display font-bold transition-colors duration-150 shadow-xl"
    >
      <ArrowUp className="size-3.5" strokeWidth={2.5} />
      Top
    </button>
  );
}
